// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"P7-z","disabled":"Q7-z","label":"R7-z"};